/* eslint-disable */
import * as Types from '../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const EditProfileDocument = gql`
    mutation EditProfile($id: Int!, $email: String!, $password: String, $passwordConfirmed: String, $firstName: String, $lastName: String, $phone: String, $countryId: Int, $companyName: String, $companyAddress: String, $companyEmail: String, $companyWebsite: String, $companyTaxVat: String) {
  profileEdit(
    id: $id
    email: $email
    password: $password
    passwordConfirmed: $passwordConfirmed
    firstName: $firstName
    lastName: $lastName
    phone: $phone
    countryId: $countryId
    companyName: $companyName
    companyAddress: $companyAddress
    companyEmail: $companyEmail
    companyWebsite: $companyWebsite
    companyTaxVat: $companyTaxVat
  ) {
    id
    email
    firstName
    lastName
    phone
    country {
      id
      title
    }
  }
}
    `;
export type EditProfileMutationFn = Apollo.MutationFunction<EditProfileMutation, EditProfileMutationVariables>;

/**
 * __useEditProfileMutation__
 *
 * To run a mutation, you first call `useEditProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editProfileMutation, { data, loading, error }] = useEditProfileMutation({
 *   variables: {
 *      id: // value for 'id'
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      passwordConfirmed: // value for 'passwordConfirmed'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      phone: // value for 'phone'
 *      countryId: // value for 'countryId'
 *      companyName: // value for 'companyName'
 *      companyAddress: // value for 'companyAddress'
 *      companyEmail: // value for 'companyEmail'
 *      companyWebsite: // value for 'companyWebsite'
 *      companyTaxVat: // value for 'companyTaxVat'
 *   },
 * });
 */
export function useEditProfileMutation(baseOptions?: Apollo.MutationHookOptions<EditProfileMutation, EditProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditProfileMutation, EditProfileMutationVariables>(EditProfileDocument, options);
      }
export type EditProfileMutationHookResult = ReturnType<typeof useEditProfileMutation>;
export type EditProfileMutationResult = Apollo.MutationResult<EditProfileMutation>;
export type EditProfileMutationOptions = Apollo.BaseMutationOptions<EditProfileMutation, EditProfileMutationVariables>;
export const ProfileDeleteDocument = gql`
    mutation ProfileDelete($id: Int!) {
  profileDelete(id: $id)
}
    `;
export type ProfileDeleteMutationFn = Apollo.MutationFunction<ProfileDeleteMutation, ProfileDeleteMutationVariables>;

/**
 * __useProfileDeleteMutation__
 *
 * To run a mutation, you first call `useProfileDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProfileDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [profileDeleteMutation, { data, loading, error }] = useProfileDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProfileDeleteMutation(baseOptions?: Apollo.MutationHookOptions<ProfileDeleteMutation, ProfileDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProfileDeleteMutation, ProfileDeleteMutationVariables>(ProfileDeleteDocument, options);
      }
export type ProfileDeleteMutationHookResult = ReturnType<typeof useProfileDeleteMutation>;
export type ProfileDeleteMutationResult = Apollo.MutationResult<ProfileDeleteMutation>;
export type ProfileDeleteMutationOptions = Apollo.BaseMutationOptions<ProfileDeleteMutation, ProfileDeleteMutationVariables>;
export const GeoDataDocument = gql`
    query GeoData {
  geoData {
    latitude
    longitude
    city
    country
    countryIsoCode
  }
}
    `;

/**
 * __useGeoDataQuery__
 *
 * To run a query within a React component, call `useGeoDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeoDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeoDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGeoDataQuery(baseOptions?: Apollo.QueryHookOptions<GeoDataQuery, GeoDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GeoDataQuery, GeoDataQueryVariables>(GeoDataDocument, options);
      }
export function useGeoDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GeoDataQuery, GeoDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GeoDataQuery, GeoDataQueryVariables>(GeoDataDocument, options);
        }
// @ts-ignore
export function useGeoDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GeoDataQuery, GeoDataQueryVariables>): Apollo.UseSuspenseQueryResult<GeoDataQuery, GeoDataQueryVariables>;
export function useGeoDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GeoDataQuery, GeoDataQueryVariables>): Apollo.UseSuspenseQueryResult<GeoDataQuery | undefined, GeoDataQueryVariables>;
export function useGeoDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GeoDataQuery, GeoDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GeoDataQuery, GeoDataQueryVariables>(GeoDataDocument, options);
        }
export type GeoDataQueryHookResult = ReturnType<typeof useGeoDataQuery>;
export type GeoDataLazyQueryHookResult = ReturnType<typeof useGeoDataLazyQuery>;
export type GeoDataSuspenseQueryHookResult = ReturnType<typeof useGeoDataSuspenseQuery>;
export type GeoDataQueryResult = Apollo.QueryResult<GeoDataQuery, GeoDataQueryVariables>;
export type EditProfileMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
  email: Types.Scalars['String']['input'];
  password?: Types.InputMaybe<Types.Scalars['String']['input']>;
  passwordConfirmed?: Types.InputMaybe<Types.Scalars['String']['input']>;
  firstName?: Types.InputMaybe<Types.Scalars['String']['input']>;
  lastName?: Types.InputMaybe<Types.Scalars['String']['input']>;
  phone?: Types.InputMaybe<Types.Scalars['String']['input']>;
  countryId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  companyName?: Types.InputMaybe<Types.Scalars['String']['input']>;
  companyAddress?: Types.InputMaybe<Types.Scalars['String']['input']>;
  companyEmail?: Types.InputMaybe<Types.Scalars['String']['input']>;
  companyWebsite?: Types.InputMaybe<Types.Scalars['String']['input']>;
  companyTaxVat?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type EditProfileMutation = { __typename?: 'Mutation', profileEdit: { __typename?: 'GraphUser', id?: number | null, email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, country?: { __typename?: 'GraphCountry', id?: number | null, title: string } | null } };

export type ProfileDeleteMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type ProfileDeleteMutation = { __typename?: 'Mutation', profileDelete: boolean };

export type GeoDataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GeoDataQuery = { __typename?: 'Query', geoData: { __typename?: 'GraphGeo', latitude?: number | null, longitude?: number | null, city?: string | null, country?: string | null, countryIsoCode?: string | null } };
